"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/heroSection.tsx */

import { HeaderSectionProps } from "@/Templates/SectionsProps";
import GeneratedHeaderSection from "../../Components/GeneratedHeaderSection";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type HeroSectionCirclesItem = {
    key: Key | null | undefined;
    /** Detected variants: "circle" */
    className?: string;
};

type HeroSectionBannerSeventeenFadeInDownsItem = {
    key: Key | null | undefined;
    /** Detected variants: "1.5s" | "2s" | "2.5s" */
    dataWowDuration: string;
    /** Detected variants: "Certified" | "Personalized" | "Seasonal" */
    h20Text: ReactNode;
    /** Detected variants: "Practitioners" | "Care" | "wellness guides" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/icons/banner-icon-05.svg" | "/Templates/Doccure/img/icons/banner-icon-06.svg" | "/Templates/Doccure/img/icons/banner-icon-07.svg" */
    src: string;
    /** Detected variants: "banner-item-seventeen wow fadeInDown" */
    className?: string;
    /** Detected variants: "section-title" */
    h20ClassName?: string;
    /** Detected variants: "banner" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};
export type HomeSeventeenHeroSectionGeneratedProps = {
    headerSectionProps?: HeaderSectionProps;
    divDiv0Div0Div0ClassName?: string;
    /** Default: "1s" */
    divDiv0Div0Div0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Holistic Health & Recovery Center" */
    divDiv0Div0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "1.5s" */
    divDiv0Div0Div0Div0Div0Div1DivDataWowDuration?: string;
    /** Default: "#" */
    divDiv0Div0Div0Div0Div0Div1A0AHref?: string;
    /** Default: "View All Services" */
    divDiv0Div0Div0Div0Div0Div1A0Span0SpanText?: ReactNode;
    /** Default: "1.5s" */
    divDiv0Div0Div0Div0Div0H10H1DataWowDuration?: string;
    divDiv0Div0Div0Div0Div0H10H1Visible?: boolean;
    divDiv0Div0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "Discover Your Path to" */
    divDiv0Div0Div0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "Holistic Wellness" */
    divDiv0Div0Div0Div0Div0H10Span1SpanText?: ReactNode;
    /** Default: "1.5s" */
    divDiv0Div0Div0Div0Div0P0PDataWowDuration?: string;
    /** Default: "Experience transformative healing through our integrative approach that nurtures body, mind, and spirit. Your journey to vibrant health and lasting peace begins here." */
    divDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "2s" */
    divDiv0Div0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "Restore. Reconnect. Thrive." */
    divDiv0Div0Div0Div1Div0Div0DivText?: ReactNode;
    /** Default: "banner-img-02" */
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-02.png" */
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img-02" */
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-03.png" */
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageSrc?: string;
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: HeroSectionBannerSeventeenFadeInDownsItem) => Partial<ComponentProps<"h2">>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HeroSectionBannerSeventeenFadeInDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    heroSectionCircles: HeroSectionCirclesItem[];
    heroSectionBannerSeventeenFadeInDowns: HeroSectionBannerSeventeenFadeInDownsItem[];
    heroSectionCirclesItemWrapper?: (item: HeroSectionCirclesItem, content: ReactNode) => ReactNode;
    heroSectionCirclesRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionBannerSeventeenFadeInDownsItemWrapper?: (item: HeroSectionBannerSeventeenFadeInDownsItem, content: ReactNode) => ReactNode;
    heroSectionBannerSeventeenFadeInDownsRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionBannerSeventeenFadeInDownsImageVisible?: boolean;
    heroSectionBannerSeventeenFadeInDownsImageRenderer?: (item: HeroSectionBannerSeventeenFadeInDownsItem, defaultNode: ReactNode) => ReactNode;
    heroSectionBannerSeventeenFadeInDownsH2Visible?: boolean;
    heroSectionBannerSeventeenFadeInDownsH2Renderer?: (item: HeroSectionBannerSeventeenFadeInDownsItem, defaultNode: ReactNode) => ReactNode;
    heroSectionBannerSeventeenFadeInDownsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HeroSectionBannerSeventeenFadeInDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    heroSectionBannerSeventeenFadeInDownsH2Props?: Partial<ComponentProps<"h2">> | ((item: HeroSectionBannerSeventeenFadeInDownsItem) => Partial<ComponentProps<"h2">>);
};

const HomeSeventeenHeroSectionGenerated: FC<HomeSeventeenHeroSectionGeneratedProps> = ({
    headerSectionProps,
    divDiv0Div0Div0Div0Div0Div0DivDataWowDuration = "1s",
    divDiv0Div0Div0Div0Div0Div0DivText = "Holistic Health & Recovery Center",
    divDiv0Div0Div0Div0Div0Div1A0AHref = "#",
    divDiv0Div0Div0Div0Div0Div1A0Span0SpanText = "View All Services",
    divDiv0Div0Div0Div0Div0Div1DivDataWowDuration = "1.5s",
    divDiv0Div0Div0Div0Div0H10H1DataWowDuration = "1.5s",
    divDiv0Div0Div0Div0Div0H10H1Visible,
    divDiv0Div0Div0Div0Div0H10H1Renderer,
    divDiv0Div0Div0Div0Div0H10H1Props,
    divDiv0Div0Div0Div0Div0H10Span0SpanText = "Discover Your Path to",
    divDiv0Div0Div0Div0Div0H10Span1SpanText = "Holistic Wellness",
    divDiv0Div0Div0Div0Div0P0PDataWowDuration = "1.5s",
    divDiv0Div0Div0Div0Div0P0PText = "Experience transformative healing through our integrative approach that nurtures body, mind, and spirit. Your journey to vibrant health and lasting peace begins here.",
    divDiv0Div0Div0Div1Div0Div0DivText = "Restore. Reconnect. Thrive.",
    divDiv0Div0Div0Div1Div0DivDataWowDuration = "2s",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt = "banner-img-02",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-img-02.png",
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageAlt = "banner-img-02",
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/banner/banner-img-03.png",
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageVisible,
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageRenderer,
    divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageProps,
    divH20H2Props,
    divImageWithBasePath0ImageProps,
    divDiv0Div0Div0ClassName,
    heroSectionCircles,
    heroSectionBannerSeventeenFadeInDowns,
    heroSectionCirclesItemWrapper,
    heroSectionCirclesRenderer,
    heroSectionBannerSeventeenFadeInDownsItemWrapper,
    heroSectionBannerSeventeenFadeInDownsRenderer,
    heroSectionBannerSeventeenFadeInDownsImageVisible,
    heroSectionBannerSeventeenFadeInDownsImageRenderer,
    heroSectionBannerSeventeenFadeInDownsH2Visible,
    heroSectionBannerSeventeenFadeInDownsH2Renderer,
    heroSectionBannerSeventeenFadeInDownsImageProps,
    heroSectionBannerSeventeenFadeInDownsH2Props,
}) => {
    return (
        <div className="hero-section-seventeen">
            {headerSectionProps?.pageData ? <GeneratedHeaderSection pageData={headerSectionProps.pageData} setting={{ Appearance: { Id: -1, Name: "Home17", Key: CenterOptions.SiteTemplate.SiteTemplateSettings.SiteTemplateHeroAppearance.Home17.key, Priority: -1 }, HeroImage: { Id: -1, Name: "", Size: 0 }, HeroButtonDisplayStatus: { Id: -1, Name: "", Key: "", Priority: -1 }, HeroVideoDisplayStatus: { Id: -1, Name: "", Key: "", Priority: -1 }, HeroVideoImage: { Id: -1, Name: "", Size: 0 }, HeroVideoLink: { Id: -1, Name: "", Size: 0 } }} lists={{ HeroAvatars: [], HeroStatistics: [], SideImages: [] }} /> : null}
            <div className="banner-section-seventeen">
                <div className="container">
                    <div className={divDiv0Div0Div0ClassName ?? "row align-items-end"}>
                        <div className="col-lg-6">
                            <div className="banner-content">
                                <div className="subtitle wow fadeInDown" data-wow-duration={divDiv0Div0Div0Div0Div0Div0DivDataWowDuration}>{divDiv0Div0Div0Div0Div0Div0DivText}</div>
                                {renderNode(divDiv0Div0Div0Div0Div0H10H1Visible, divDiv0Div0Div0Div0Div0H10H1Renderer, (
                                    <h1 className="title wow fadeInDown" data-wow-duration={divDiv0Div0Div0Div0Div0H10H1DataWowDuration} {...(divDiv0Div0Div0Div0Div0H10H1Props ?? {})}>
                                        <span className="primary">{divDiv0Div0Div0Div0Div0H10Span0SpanText}</span>
                                        <span className="secondary">{divDiv0Div0Div0Div0Div0H10Span1SpanText}</span>
                                    </h1>
                                ))}
                                <p className="description wow fadeInDown" data-wow-duration={divDiv0Div0Div0Div0Div0P0PDataWowDuration}>
                                    {divDiv0Div0Div0Div0Div0P0PText}
                                    {" "}
                                </p>
                                <div className="banner-link wow fadeInDown" data-wow-duration={divDiv0Div0Div0Div0Div0Div1DivDataWowDuration}>
                                    <a href={divDiv0Div0Div0Div0Div0Div1A0AHref} className="theme-17-btn">
                                        <span className="text">{divDiv0Div0Div0Div0Div0Div1A0Span0SpanText}</span>
                                        <span className="icon">
                                            <i className="isax isax-arrow-right-1"></i>
                                        </span>
                                        <div className="container-stars">
                                            <div className="stars"></div>
                                        </div>
                                        <div className="glow">
                                            {renderCollectionNode(
                                                heroSectionCircles,
                                                (item: HeroSectionCirclesItem) => (
                                                    <div className={item.className ?? "circle"} key={item.key}></div>
                                                ),
                                                heroSectionCirclesItemWrapper,
                                                heroSectionCirclesRenderer
                                            )}
                                        </div>
                                    </a>
                                </div>
                                <div className="banner-list">
                                    {renderCollectionNode(
                                        heroSectionBannerSeventeenFadeInDowns,
                                        (item: HeroSectionBannerSeventeenFadeInDownsItem) => (
                                            <div className={item.className ?? "banner-item-seventeen wow fadeInDown"} data-wow-duration={item.dataWowDuration} key={item.key}>
                                                {renderItemNode(heroSectionBannerSeventeenFadeInDownsImageVisible, heroSectionBannerSeventeenFadeInDownsImageRenderer, item, (
                                                    <SmartImage src={item.src} className={item.imageWithBasePath0ClassName ?? "img-fluid"} alt={item.alt ?? "banner"} {...(typeof heroSectionBannerSeventeenFadeInDownsImageProps === "function" ? heroSectionBannerSeventeenFadeInDownsImageProps(item) : (heroSectionBannerSeventeenFadeInDownsImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                                {renderItemNode(heroSectionBannerSeventeenFadeInDownsH2Visible, heroSectionBannerSeventeenFadeInDownsH2Renderer, item, (
                                                    <h2 className={item.h20ClassName ?? "section-title"} {...(typeof heroSectionBannerSeventeenFadeInDownsH2Props === "function" ? heroSectionBannerSeventeenFadeInDownsH2Props(item) : (heroSectionBannerSeventeenFadeInDownsH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>
                                                        {item.h20Text}
                                                        <span>{item.span0Text}</span>
                                                    </h2>
                                                ))}
                                            </div>
                                        ),
                                        heroSectionBannerSeventeenFadeInDownsItemWrapper,
                                        heroSectionBannerSeventeenFadeInDownsRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="banner-img wow zoomIn" data-wow-duration={divDiv0Div0Div0Div1Div0DivDataWowDuration}>
                                {renderNode(divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid banner-img-two" {...(divDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {renderNode(divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageVisible, divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageRenderer, (
                                    <SmartImage src={divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageSrc} alt={divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageAlt} className="img-fluid banner-img-three" {...(divDiv0Div0Div0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                                ))}
                                <div className="img-content">
                                    <span className="icon">
                                        <i className="isax isax-arrow5"></i>
                                    </span>
                                    {divDiv0Div0Div0Div1Div0Div0DivText}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeSeventeenHeroSectionGenerated;
